import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import apiFun from "@/http/api.js";

import "amfe-flexible";
import Vant from "vant";
import "vant/lib/index.css";
import "@/assets/css/mobile-fix.css";

Vue.use(Vant);

Vue.prototype.$apiFun = apiFun;

Vue.config.productionTip = false;

document.documentElement.style.overflowX = "hidden";
document.body.style.overflowX = "hidden";
document.body.style.width = "100%";
document.body.style.maxWidth = "100%";

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0); //每到一个新的页面 就自动回顶
  if (document.querySelector(".index-page")) {
    document.querySelector(".index-page").scrollTo(0, 0); //
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((res) => res.meta.requireAuth)) {
    // 验证是否需要登陆
    if (sessionStorage.getItem("token")) {
      // 查询本地存储信息是否已经登陆
      next();
    } else {
      next({
        path: "/login", // 未登录则跳转至login页面
        query: { redirect: to.fullPath }, // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      });
    }
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
